// extracted by mini-css-extract-plugin
export default {"bold":"Space_bold__wnsaI"};